import { useEffect } from "react";
import Navbar from "../components/NavBar";
import Promo from "../components/Promo";

const PromoPage = () => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "PROMO | BildUp";

    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <div className="App font-sans text-gray-900">
      <Navbar />
      <main>
        <Promo />
      </main>
    </div>
  );
};

export default PromoPage;
